import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function FindMyPhotos() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/orders/lookup", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 md:px-12 mt-16 pb-24" data-testid="find-my-photos-page">
      <p className="text-xs uppercase tracking-[0.3em] text-white/40">Lost your download link?</p>
      <h1 className="font-serif text-5xl md:text-6xl font-light leading-none mt-3">
        Find my <span className="pm-orange">photos</span>
      </h1>
      <p className="text-white/65 mt-6 leading-relaxed">
        Enter the email you used at checkout and we'll send you a fresh email with every
        still-valid download link — no account needed.
      </p>

      {sent ? (
        <div className="mt-10 border border-white/15 p-8 text-center" data-testid="lookup-sent">
          <MailCheck size={36} className="mx-auto pm-orange" />
          <p className="text-white/80 mt-5 leading-relaxed">
            If we have purchases for <span className="pm-orange font-semibold">{email}</span>,
            a download email is on its way. Check your spam folder too.
          </p>
          <button
            onClick={() => setSent(false)}
            className="mt-6 text-xs uppercase tracking-[0.3em] text-white/50 hover:text-white underline underline-offset-4"
            data-testid="lookup-again"
          >
            Use a different email
          </button>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-2">Checkout email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="input-minimal"
              data-testid="lookup-email-input"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-white text-black py-5 text-xs uppercase tracking-[0.3em] font-medium hover:bg-white/90 transition disabled:opacity-50"
            data-testid="lookup-submit"
          >
            {busy ? "Sending…" : "Email me my download links"}
          </button>
          <p className="text-xs text-white/40 leading-relaxed">
            For your security we never show download links on screen — they're only ever sent
            to the email address that made the purchase.
          </p>
        </form>
      )}
    </div>
  );
}
